// This file contains the list of countries where ads should be removed from the BuyBox.
export const removeAdsCountries = ['FR', 'DE'];
